import Layout from "../include/layout";
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import { useEffect, useState } from "react";
import $ from "jquery"
import Swal from "sweetalert2";
import dayjs from "dayjs";
import 'datatables.net-dt'
import VentesServices from "../../services/VentesServices";
import { useSelector } from "react-redux";

export default function Ventes() {

    //##########################/// METHODES ##########################///
    const [ventes, setVentes] = useState([])
    const navigate = useNavigate();
    const token = useSelector(state => state.auth.token)

    //gestion des modals
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    //get liste publications
    const fetchVentes = async () => {
        await VentesServices.ventes(token).then((res) => {
            //console.log(res.data)
            setVentes(res.data.liste_ventes_qt)
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
        })

        //initialize datatable
        $(document).ready(function () {            
            $('.data-table').DataTable();
        });
    }


    useEffect(() => {
        fetchVentes();
        $("#submenu-3").addClass("show")
    }, [])


    //##########################/// END METHODES ##########################///


    return (
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0">Administration</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item active">Médias </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Liste des ventes Quotidiennes</h1>
                        </div>
                        <div className="col-auto">
                            <div className="page-utilities">
                                <div className="row g-2 justify-content-start justify-content-md-end align-items-center">

                                    <div className="col-auto">
                                        <a className="btn app-btn-primary" href="#">
                                            <i className="fas fa-file-excel"></i>&nbsp;
                                            Excel
                                        </a>
                                    </div>
                                    <div className="col-auto">
                                        <a className="btn btn-danger" href="#">
                                            <i className="fas fa-file-pdf"></i>&nbsp;
                                            Pdf
                                        </a>
                                    </div>
                                </div>{/*//row*/}
                            </div>{/*//table-utilities*/}
                        </div>{/*//col-auto*/}
                    </div>{/*//row*/}

                    <div className="app-card app-card-orders-table shadow-lg mb-5">
                        <div className="app-card-body mx-3 py-2">
                            <div className="table-responsive mt-4">
                                <table className="table table-borderless table-hover app-table-hover mb-0 text-left data-table">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="cell text-white">N°</th>
                                            <th className="cell text-white">Auteur</th>
                                            <th className="cell text-white">Publications</th>
                                            <th className="cell text-white">Montant cession</th>
                                            <th className="cell text-white">Montant KD</th>
                                            <th className="cell text-white">Montant</th>
                                            <th className="cell text-white">Date achat</th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-group-divider">
                                        {ventes.length > 0  && ventes.map((item, index) => (
                                            <tr>
                                                <td className="cell">{index + 1}</td>
                                                <td className="cell">{
                                                    (item.get_publication.auteur_id !== "") ?
                                                        (item.auteur_id ? item.get_publication.get_auteur.nom_auteur + "" + item.get_publication.get_auteur.prenoms_auteur : "") :
                                                        (item.editeur_id ? item.get_editeur.raison_sociale : " ")}
                                                </td>
                                                <td className="cell"><span className="truncate">{item.get_publication.titre_concatene}</span></td>
                                                <td className="cell">{item.get_publication.montant_cession}F CFA</td>
                                                <td className="cell">{(item.get_publicationmontant_publication - item.montant_cession)}F CFA</td>
                                                <td className="cell">{item.get_publication.montant_publication}F CFA</td>
                                                <td className="cell"><span>{dayjs(item.date_paiement).format("DD/MM/YYYY H:m:s")} </span>
                                                </td>
                                            </tr>
                                        ))}


                                    </tbody>
                                </table>
                            </div>{/*//table-responsive*/}

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}
                

                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}